module.exports = __webpack_public_path__ + "img/insert_green.c3e1f5c1.svg";